export enum PaymentMethod {
  CREDIT_CARD = 'CREDIT_CARD',
  BOLETO_PIX = 'BOLETO_PIX',
  BOLETO = 'BOLETO',
  PIX = 'PIX'
}
